import Head from "next/head";
import type {NextPage} from "next";
import {useRouter} from "next/router";
import {TrackingView} from "../components/customer/TrackingView";
import {handleLogout} from "components/utils"; import React from "react";

const Customer: NextPage = (props) => {

    const router = useRouter()
    const trackingId = router.query["t"]? router.query["t"].toString()  : null

    return (
        <div>
            <Head>
                <title>QMe - Live Patient Tracking</title>
                <meta name="description" content="QMe - Live Patient Tracking"/>
                <meta name="keywords" content="Token based appointment system, smart queues, queue management system in hospital, hospital information system"/>
                <meta name="robots" content="noindex, nofollow"/>
            </Head>
            <div className="bg-white"><TrackingView trackingId={trackingId}/></div>
        </div>
    );
};


export default Customer;
